import React, { useEffect, useContext, useState } from "react";
import { MdPerson, MdPeople } from "react-icons/md";

import { collection, query, where, onSnapshot } from "firebase/firestore";

import {AuthContext} from '../services/Session/Context'
import {FirebaseContext} from '../services/Firebase/Context'

const TeamCard = () => {
  const { db } = useContext(FirebaseContext)
  const { user } = useContext(AuthContext)
  const [users, setUsers] = useState()

  useEffect(() => {
    if(!user) return
    const q = query(collection(db, "users"), where("organisationId", "==", user.organisationId));
    const unsubscribe = onSnapshot(q, (querySnapshot) => {
      const users = [];
      querySnapshot.forEach((doc) => {
        if(doc.id === user.uid) return
        users.push(doc.data());
      });
      setUsers(users)
    });
    return () => unsubscribe()
  }, [db, user])

  return (
    <form className="shadow-md mt-5">
      <div className="p-4 bg-gray-100 border-t-2 border-blue-400 rounded-lg bg-opacity-5">
        <div className="max-w-sm mx-auto md:w-full md:mx-0">
          <div className="inline-flex items-center space-x-4">
            <MdPeople className="bg-blue-200 rounded-full h-10 w-10 p-2" color="white" />
              <h1 className="text-gray-600">
                Mon équipe
              </h1>
          </div>
        </div>
      </div>
      <div className="space-y-6 bg-white">
        <div className="text-gray-500 flex-col flex w-full py-5">
          {
            users && users.map(({ firstName, lastName, email }) => <li key={email} className="flex flex-row">
              <div className="select-none cursor-pointer flex flex-1 items-center p-4">
                  <div className="flex flex-col w-10 h-10 justify-center items-center mr-4">
                    <MdPerson className="bg-gray-200 rounded-full h-10 w-10 p-2" color="white" />
                  </div>
                  <div className="flex-1 pl-1 mr-16">
                      <div className="font-medium dark:text-white">
                        {firstName} {lastName.charAt(0)}
                      </div>
                      {/*<div className="text-gray-600 dark:text-gray-200 text-sm">
                        Developer
                      </div>*/}
                  </div>
                  <div className="text-gray-600 dark:text-gray-200 text-xs">
                    <a href={`mailto:${email}`}>Contacter</a>
                  </div>
              </div>
            </li>)
          }
          { (!users || users.length === 0) && <span className="text-center w-full">Aucun membre</span>}
        </div>
      </div>
    </form>
  );
}

export default TeamCard
